export default "__VITE_ASSET__rFc$33CS__"